import { render, staticRenderFns } from "./SelectorMonitor.vue?vue&type=template&id=b803d162"
import script from "./SelectorMonitor.vue?vue&type=script&lang=js"
export * from "./SelectorMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b803d162')) {
      api.createRecord('b803d162', component.options)
    } else {
      api.reload('b803d162', component.options)
    }
    module.hot.accept("./SelectorMonitor.vue?vue&type=template&id=b803d162", function () {
      api.rerender('b803d162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/SelectorMonitor.vue"
export default component.exports